import { cx } from '@emotion/css';
import desertIllustration from '@/assets/desert.png';
import styles from './EmptyState.styles';
import { BodyMedium, TitleSmallEmphasized } from '@/design-system';
import colors from '@/theme/colors';

interface EmptyStateProps {
  title: string;
  description?: React.ReactNode;
  illustration?: string;
  bottom?: React.ReactNode;
  dataTestId?: string;
  titleColor?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  illustration = desertIllustration,
  bottom,
  titleColor = colors.slate,
  dataTestId,
}) => {
  return (
    <div className={styles.container} data-testid={dataTestId}>
      <div className={styles.illustration}>
        <img
          src={illustration}
          width="260px"
          height="100%"
          alt={title}
          data-testid="illustration"
        />
      </div>
      <TitleSmallEmphasized color={titleColor} className={styles.textCenter} data-testid="title">
        {title}
      </TitleSmallEmphasized>
      <BodyMedium
        className={cx(styles.description, styles.textCenter)}
        color={colors.slate}
        data-testid="description"
      >
        {description}
      </BodyMedium>
      {bottom && (
        <div className={styles.bottom} data-testid="bottomContainer">
          {bottom}
        </div>
      )}
    </div>
  );
};
